/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIShippingStatusEnum } from './APIShippingStatusEnum';
import {
    APIShippingStatusEnumFromJSON,
    APIShippingStatusEnumFromJSONTyped,
    APIShippingStatusEnumToJSON,
} from './APIShippingStatusEnum';

/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIShippingRequest
 */
export interface APIShippingRequest {
    /**
     * 
     * @type {number}
     * @memberof APIShippingRequest
     */
    amount: number;
    /**
     * 
     * @type {Date}
     * @memberof APIShippingRequest
     */
    dueDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof APIShippingRequest
     */
    wishDate: Date;
    /**
     * 
     * @type {string}
     * @memberof APIShippingRequest
     */
    address: string;
    /**
     * 
     * @type {APIShippingStatusEnum}
     * @memberof APIShippingRequest
     */
    shippingStatus: APIShippingStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof APIShippingRequest
     */
    trackingNumber: string;
}



/**
 * Check if a given object implements the APIShippingRequest interface.
 */
export function instanceOfAPIShippingRequest(value: object): value is APIShippingRequest {
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('dueDate' in value) || value['dueDate'] === undefined) return false;
    if (!('wishDate' in value) || value['wishDate'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('shippingStatus' in value) || value['shippingStatus'] === undefined) return false;
    if (!('trackingNumber' in value) || value['trackingNumber'] === undefined) return false;
    return true;
}

export function APIShippingRequestFromJSON(json: any): APIShippingRequest {
    return APIShippingRequestFromJSONTyped(json, false);
}

export function APIShippingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIShippingRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'],
        'dueDate': (new Date(json['due_date'])),
        'wishDate': (new Date(json['wish_date'])),
        'address': json['address'],
        'shippingStatus': APIShippingStatusEnumFromJSON(json['shipping_status']),
        'trackingNumber': json['tracking_number'],
    };
}

export function APIShippingRequestToJSON(value?: APIShippingRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'amount': value['amount'],
        'due_date': ((value['dueDate']).toISOString()),
        'wish_date': ((value['wishDate']).toISOString()),
        'address': value['address'],
        'shipping_status': APIShippingStatusEnumToJSON(value['shippingStatus']),
        'tracking_number': value['trackingNumber'],
    };
}

